import { Node } from 'prosemirror-model'
import { EditorView, NodeView } from 'prosemirror-view'
import { MentionType } from '../Types'

export class SmartLink implements NodeView {
  dom: HTMLAnchorElement

  constructor(node: Node, view: EditorView) {
    this.dom = document.createElement('a')
    const { url, title, type } = node.attrs
    const prefix = type === MentionType.User ? '@' : ''
    this.dom.text = `${prefix}${title}`
    if (!view.editable) {
      this.dom.href = url
    }
  }
}
